var _defs, _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7, _circle2, _path8, _path9, _circle3, _path10, _circle4, _circle5, _path11, _circle6, _circle7, _path12, _path13, _circle8, _path14, _path15, _path16, _circle9, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _rect, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoperGameLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 770.2 200.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-2{fill:#cf4d4b;}.cls-3{fill:#c41230;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Roper_RGB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.5,22.93h53.61q17.87,0,27,9.44t9.1,26.81q0,16.62-9.85,25.89t-25.05,9.27h-6.43l42.92,55.53H302.56L256.71,87.74v62.13H236.5Zm20.21,20.21V80.47h23.63q14.95,0,20.29-4.76T306,61.26q0-18.12-21.21-18.12Z",
    transform: "translate(-10.25 -11.76)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M335.18,82.22q0-27.56,13.53-44.76t40-17.2q25.22,0,39.33,16.87t14.2,45.68q0,32.74-13.86,51.28t-39.67,18.46q-26.39,0-40-18.79T335.18,82.22Zm20.21,2.84q0,49.52,33.32,49.52T422,85.4q0-44-33.32-44T355.39,85.07Z",
    transform: "translate(-10.25 -11.76)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M456.82,22.93h51.61q40.75,0,40.75,40.67,0,43.93-44.85,43.93H477v42.34H456.82ZM477,43.14V89.57h28.64q23.3,0,23.3-24.89,0-21.55-23.72-21.55Z",
    transform: "translate(-10.25 -11.76)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M562.18,149.87V22.93h76.33V43.14H582.39V77.63h56.12v18H582.39v36.33h56.12v18Z",
    transform: "translate(-10.25 -11.76)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M657.93,22.93h53.61q17.87,0,27,9.44t9.1,26.81q0,16.62-9.86,25.89t-25.05,9.27h-6.43l42.93,55.53H724L678.14,87.74v62.13H657.93Zm20.21,20.21V80.47h23.63q14.95,0,20.29-4.76t5.35-14.45q0-18.12-21.21-18.12Z",
    transform: "translate(-10.25 -11.76)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 108.07,
    cy: 62.48,
    r: 13.85,
    transform: "matrix(0.28, -0.96, 0.96, 0.28, 7.83, 137.24)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.8,152.94A13.85,13.85,0,1,1,128,139.1,13.86,13.86,0,0,1,141.8,152.94Z",
    transform: "translate(-10.25 -11.76)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.84,161.21A13.85,13.85,0,1,1,100,147.34,13.85,13.85,0,0,1,113.84,161.21Z",
    transform: "translate(-10.25 -11.76)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 89.74,
    cy: 178.14,
    r: 13.85
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M124.42,23.9a6.57,6.57,0,1,1,2.11-9A6.58,6.58,0,0,1,124.42,23.9Z",
    transform: "translate(-10.25 -11.76)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120.07,44.76a8.6,8.6,0,1,1,2.76-11.84A8.61,8.61,0,0,1,120.07,44.76Z",
    transform: "translate(-10.25 -11.76)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 146.14,
    cy: 130.92,
    r: 13.85,
    transform: "translate(-34.47 216.49) rotate(-71.59)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M184.51,148.83a6.57,6.57,0,1,1,9,2.47A6.58,6.58,0,0,1,184.51,148.83Z",
    transform: "translate(-10.25 -11.76)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 171.84,
    cy: 139.75,
    r: 8.6,
    transform: "translate(-56.83 91.27) rotate(-29.58)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 148.78,
    cy: 101.27,
    r: 13.85,
    transform: "translate(-22.7 9.54) rotate(-7.86)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M191.12,100.36a6.57,6.57,0,1,1,9.12-1.74A6.58,6.58,0,0,1,191.12,100.36Z",
    transform: "translate(-10.25 -11.76)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 175.27,
    cy: 97.8,
    r: 8.6,
    transform: "translate(-14.33 176.14) rotate(-55.83)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 134.39,
    cy: 75.54,
    r: 13.85,
    transform: "translate(-28.66 84.22) rotate(-36.96)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M170.94,54.15a6.57,6.57,0,1,1,7.12-6A6.58,6.58,0,0,1,170.94,54.15Z",
    transform: "translate(-10.25 -11.76)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M155.2,68.15a8.6,8.6,0,1,1,9.32-7.8A8.6,8.6,0,0,1,155.2,68.15Z",
    transform: "translate(-10.25 -11.76)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 78.81,
    cy: 66.9,
    r: 13.85,
    transform: "translate(-30.96 27.18) rotate(-24.63)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.3,26.63A6.57,6.57,0,1,1,60,18.4,6.58,6.58,0,0,1,64.3,26.63Z",
    transform: "translate(-10.25 -11.76)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75.45,45.57A8.6,8.6,0,1,1,69.81,34.8,8.6,8.6,0,0,1,75.45,45.57Z",
    transform: "translate(-10.25 -11.76)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.91,74.75a13.85,13.85,0,1,1-19,5A13.86,13.86,0,0,1,63.91,74.75Z",
    transform: "translate(-10.25 -11.76)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 16.81,
    cy: 63.25,
    r: 6.57,
    transform: "translate(-28.63 -3.68) rotate(-17.65)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.79,71.71A8.6,8.6,0,1,1,31,66.13,8.61,8.61,0,0,1,41.79,71.71Z",
    transform: "translate(-10.25 -11.76)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M758,38.43A11,11,0,0,1,756.07,32a8.16,8.16,0,0,1,3.13-6.93q3.13-2.37,9.05-2.37,5.72,0,9,2.3t3.24,7a13.34,13.34,0,0,1-.43,3.36,8.34,8.34,0,0,1-1.15,2.68l-2.15-.9A10.23,10.23,0,0,0,778,32a5.42,5.42,0,0,0-2.36-4.83q-2.35-1.58-7.45-1.58-9.79,0-9.78,6.41a11,11,0,0,0,1.66,5.56Z",
    transform: "translate(-10.25 -11.76)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M756.52,59.28V47H780V59.18h-2.38V49.75h-7.27v9.07H768V49.75h-9.07v9.54Z",
    transform: "translate(-10.25 -11.76)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M756.52,82.22v-3l18.54-8.42H756.52V68H780v3l-18.37,8.45H780v2.68Z",
    transform: "translate(-10.25 -11.76)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M777.78,105.92V98.68H756.52V96h21.27V88.7H780v17.22Z",
    transform: "translate(-10.25 -11.76)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M756.52,125.75V113.48H780v12.16h-2.38v-9.43h-7.27v9.07H768v-9.07h-9.07v9.53Z",
    transform: "translate(-10.25 -11.76)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M756.52,150.92v-3.41l10.67-6.89v-3H756.52v-2.73H780v6.64a8,8,0,0,1-1.62,5.28,5.56,5.56,0,0,1-4.52,1.94,5.75,5.75,0,0,1-3.82-1.41,7.11,7.11,0,0,1-2.27-3.9Zm13-13.33V141a5.15,5.15,0,0,0,1.17,3.51,3.75,3.75,0,0,0,3,1.35q3.93,0,3.93-4.79v-3.51Z",
    transform: "translate(-10.25 -11.76)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 223.43,
    y: 159.77,
    width: 544.99,
    height: 1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.19,188.88H245v2h-7.45v6h6.88v1.94h-6.88v8.23h-2.35Z",
    transform: "translate(-10.25 -11.76)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268.15,200.43c0,4.83-3.35,6.94-6.51,6.94-3.54,0-6.26-2.59-6.26-6.72,0-4.37,2.86-6.94,6.48-6.94S268.15,196.43,268.15,200.43Zm-10.37.13c0,2.86,1.65,5,4,5s4-2.13,4-5.07c0-2.21-1.11-5-3.91-5S257.79,198.08,257.79,200.56Z",
    transform: "translate(-10.25 -11.76)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.06,198.08c0-1.54,0-2.86-.11-4.08H282l.08,2.56h.11a3.92,3.92,0,0,1,3.62-2.86,2.58,2.58,0,0,1,.67.08V196a3.59,3.59,0,0,0-.81-.08,3.33,3.33,0,0,0-3.19,3.05,6.7,6.7,0,0,0-.11,1.11v7h-2.35Z",
    transform: "translate(-10.25 -11.76)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M312.52,189.09a27.16,27.16,0,0,1,4.51-.35,7.47,7.47,0,0,1,5.1,1.51,4.89,4.89,0,0,1,1.59,3.81,5.36,5.36,0,0,1-1.4,3.89,7.54,7.54,0,0,1-5.56,2,8.09,8.09,0,0,1-1.89-.16v7.29h-2.35Zm2.35,8.77a7.89,7.89,0,0,0,1.94.19c2.83,0,4.56-1.38,4.56-3.89s-1.7-3.56-4.29-3.56a9.82,9.82,0,0,0-2.21.19Z",
    transform: "translate(-10.25 -11.76)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.24,203.51c0,1.35,0,2.54.11,3.56h-2.11l-.14-2.13h-.05a4.92,4.92,0,0,1-4.32,2.43c-2.05,0-4.51-1.13-4.51-5.72V194h2.38v7.23c0,2.48.76,4.16,2.92,4.16a3.34,3.34,0,0,0,3.35-3.37v-8h2.38Z",
    transform: "translate(-10.25 -11.76)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M359,207.07c.05-.89.11-2.21.11-3.37V187.9h2.35v8.21h.05a4.87,4.87,0,0,1,4.45-2.4c3.24,0,5.53,2.7,5.51,6.67,0,4.67-2.94,7-5.86,7a4.65,4.65,0,0,1-4.37-2.46h-.08l-.11,2.16Zm2.46-5.24a4.46,4.46,0,0,0,.11.86,3.66,3.66,0,0,0,3.56,2.78c2.48,0,4-2,4-5,0-2.62-1.35-4.86-3.89-4.86a3.79,3.79,0,0,0-3.62,2.92,4.71,4.71,0,0,0-.13,1Z",
    transform: "translate(-10.25 -11.76)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M383.37,187.9h2.38v19.17h-2.37Z",
    transform: "translate(-10.25 -11.76)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M401.29,190.33a1.47,1.47,0,0,1-2.94,0,1.45,1.45,0,0,1,1.48-1.48A1.41,1.41,0,0,1,401.29,190.33Zm-2.65,16.74V194H401v13.06Z",
    transform: "translate(-10.25 -11.76)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M423.19,206.58a8.76,8.76,0,0,1-3.75.76c-3.94,0-6.51-2.67-6.51-6.67a6.64,6.64,0,0,1,7-6.94,7.93,7.93,0,0,1,3.29.67l-.54,1.83a5.51,5.51,0,0,0-2.75-.62c-3,0-4.62,2.21-4.62,4.94,0,3,1.94,4.89,4.54,4.89a6.75,6.75,0,0,0,2.92-.65Z",
    transform: "translate(-10.25 -11.76)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M465.14,197.78c0,6.26-3.81,9.58-8.45,9.58-4.8,0-8.18-3.72-8.18-9.23,0-5.78,3.59-9.56,8.45-9.56S465.14,192.38,465.14,197.78Zm-14.12.3c0,3.89,2.11,7.37,5.8,7.37s5.83-3.43,5.83-7.56c0-3.62-1.89-7.4-5.8-7.4S451,194.09,451,198.08Z",
    transform: "translate(-10.25 -11.76)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M477,198.27c0-1.67-.05-3-.11-4.26h2.13l.11,2.24h.05a5.14,5.14,0,0,1,4.64-2.54c3.16,0,5.53,2.67,5.53,6.64,0,4.7-2.86,7-5.94,7a4.58,4.58,0,0,1-4-2.05h-.05v7.1H477Zm2.35,3.48a5.37,5.37,0,0,0,.11,1A3.67,3.67,0,0,0,483,205.5c2.51,0,4-2.05,4-5,0-2.62-1.38-4.86-3.89-4.86a3.79,3.79,0,0,0-3.59,2.94,3.85,3.85,0,0,0-.16,1Z",
    transform: "translate(-10.25 -11.76)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M503.95,190.33a1.47,1.47,0,0,1-2.94,0,1.45,1.45,0,0,1,1.48-1.48A1.41,1.41,0,0,1,503.95,190.33Zm-2.65,16.74V194h2.38v13.06Z",
    transform: "translate(-10.25 -11.76)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M516.53,197.54c0-1.35,0-2.46-.11-3.54h2.11l.13,2.16h.05a4.8,4.8,0,0,1,4.32-2.46c1.81,0,4.62,1.08,4.62,5.56v7.8h-2.38v-7.53c0-2.11-.78-3.86-3-3.86a3.48,3.48,0,0,0-3.35,3.54v7.85h-2.37Z",
    transform: "translate(-10.25 -11.76)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M543.07,190.33a1.47,1.47,0,0,1-2.94,0,1.45,1.45,0,0,1,1.48-1.48A1.41,1.41,0,0,1,543.07,190.33Zm-2.65,16.74V194h2.38v13.06Z",
    transform: "translate(-10.25 -11.76)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M567.47,200.43c0,4.83-3.35,6.94-6.5,6.94-3.54,0-6.26-2.59-6.26-6.72,0-4.37,2.86-6.94,6.48-6.94S567.47,196.43,567.47,200.43Zm-10.37.13c0,2.86,1.65,5,4,5s4-2.13,4-5.07c0-2.21-1.11-5-3.91-5S557.11,198.08,557.11,200.56Z",
    transform: "translate(-10.25 -11.76)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M579.38,197.54c0-1.35,0-2.46-.11-3.54h2.11l.13,2.16h.05a4.8,4.8,0,0,1,4.32-2.46c1.81,0,4.62,1.08,4.62,5.56v7.8h-2.38v-7.53c0-2.11-.78-3.86-3-3.86a3.48,3.48,0,0,0-3.35,3.54v7.85h-2.37Z",
    transform: "translate(-10.25 -11.76)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M618,189.12a24.43,24.43,0,0,1,4.51-.38c2.51,0,4.13.46,5.26,1.48a4.54,4.54,0,0,1,1.43,3.46,4.78,4.78,0,0,1-3.43,4.64v.08c1.4.49,2.24,1.78,2.67,3.67a28.93,28.93,0,0,0,1.4,5h-2.43a23.62,23.62,0,0,1-1.21-4.35c-.54-2.51-1.51-3.46-3.64-3.54h-2.21v7.88H618Zm2.35,8.29h2.4c2.51,0,4.1-1.38,4.1-3.46,0-2.35-1.7-3.37-4.18-3.4a9.7,9.7,0,0,0-2.32.22Z",
    transform: "translate(-10.25 -11.76)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M642.78,201c.05,3.21,2.11,4.54,4.48,4.54a8.59,8.59,0,0,0,3.62-.67l.41,1.7a10.58,10.58,0,0,1-4.35.81c-4,0-6.42-2.65-6.42-6.59s2.32-7,6.13-7c4.26,0,5.4,3.75,5.4,6.15A8.86,8.86,0,0,1,652,201Zm7-1.7c0-1.51-.62-3.86-3.29-3.86-2.4,0-3.46,2.21-3.64,3.86Z",
    transform: "translate(-10.25 -11.76)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M663.57,204.64a6.23,6.23,0,0,0,3.13.94c1.73,0,2.54-.86,2.54-1.94s-.67-1.75-2.43-2.4c-2.35-.84-3.46-2.13-3.46-3.7,0-2.11,1.7-3.83,4.51-3.83a6.52,6.52,0,0,1,3.21.81l-.59,1.73a5.09,5.09,0,0,0-2.67-.76c-1.4,0-2.19.81-2.19,1.78s.78,1.57,2.48,2.21c2.27.86,3.43,2,3.43,3.94,0,2.29-1.78,3.91-4.89,3.91a7.46,7.46,0,0,1-3.67-.89Z",
    transform: "translate(-10.25 -11.76)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M684.82,201c.05,3.21,2.11,4.54,4.48,4.54a8.59,8.59,0,0,0,3.62-.67l.41,1.7a10.58,10.58,0,0,1-4.35.81c-4,0-6.42-2.65-6.42-6.59s2.32-7,6.13-7c4.26,0,5.4,3.75,5.4,6.15A8.86,8.86,0,0,1,694,201Zm7-1.7c0-1.51-.62-3.86-3.29-3.86-2.4,0-3.46,2.21-3.64,3.86Z",
    transform: "translate(-10.25 -11.76)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M713.16,207.07l-.19-1.65h-.08a4.86,4.86,0,0,1-4,1.94,3.72,3.72,0,0,1-4-3.75c0-3.16,2.81-4.89,7.86-4.86v-.27a2.69,2.69,0,0,0-3-3,6.51,6.51,0,0,0-3.4,1l-.54-1.57a8.1,8.1,0,0,1,4.29-1.16c4,0,5,2.73,5,5.34v4.89a18.37,18.37,0,0,0,.22,3.13Zm-.35-6.67c-2.59-.05-5.53.41-5.53,2.94a2.1,2.1,0,0,0,2.24,2.27,3.25,3.25,0,0,0,3.16-2.19,2.48,2.48,0,0,0,.13-.76Z",
    transform: "translate(-10.25 -11.76)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M727.85,198.08c0-1.54,0-2.86-.11-4.08h2.08l.08,2.56H730a3.92,3.92,0,0,1,3.62-2.86,2.58,2.58,0,0,1,.67.08V196a3.59,3.59,0,0,0-.81-.08,3.33,3.33,0,0,0-3.19,3.05,6.7,6.7,0,0,0-.11,1.11v7h-2.35Z",
    transform: "translate(-10.25 -11.76)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M754.64,206.58a8.76,8.76,0,0,1-3.75.76c-3.94,0-6.51-2.67-6.51-6.67a6.64,6.64,0,0,1,7-6.94,7.93,7.93,0,0,1,3.29.67l-.54,1.83a5.51,5.51,0,0,0-2.75-.62c-3,0-4.62,2.21-4.62,4.94,0,3,1.94,4.89,4.54,4.89a6.75,6.75,0,0,0,2.92-.65Z",
    transform: "translate(-10.25 -11.76)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M766.33,187.9h2.38v8.15h.05a4.41,4.41,0,0,1,1.7-1.67,4.89,4.89,0,0,1,2.43-.67c1.75,0,4.56,1.08,4.56,5.59v7.77h-2.38v-7.5c0-2.11-.78-3.89-3-3.89a3.41,3.41,0,0,0-3.19,2.38,2.88,2.88,0,0,0-.16,1.13v7.88h-2.37Z",
    transform: "translate(-10.25 -11.76)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoperGameLogo);
export default __webpack_public_path__ + "static/media/roper_game_logo.735afc6afe7d59e5eb88951f7b6e6367.svg";
export { ForwardRef as ReactComponent };